module.exports = __webpack_public_path__ + "static/media/dexcel-pharma.bc5ee94f.png";